import React, { useCallback, useContext, useMemo, useState } from 'react';
import moment from 'moment';
import HealingIcon from '@material-ui/icons/Healing';
import { Menu, MenuItem } from '@material-ui/core';
import { Printing } from '@mummssoftware/utils';
import { Loader, usePrintDispatch } from '@mummssoftware/common-ui';
import { createPortal } from 'react-dom';
import { StyledActionIcon } from '../../components/layout/ActionIcon';
import { Context } from '../../context';

export const PlanOfCare = () => {
  const { keycloak, agency, currentUser, patient } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const printingService = useMemo(
    () =>
      new Printing({
        url: window.env.hosts.printingService,
        keycloak,
        agency,
        currentUser,
      }),
    [keycloak, agency, currentUser],
  );

  const printConfig = useMemo(
    () => ({
      CarePlanProblems: { view: 'Contents' as const },
      CarePlanFrequency: true,
      ClearScripts: { view: 'Active' as const },
      fromDate: moment().format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
    }),
    [],
  );

  const getPrintPromise = useCallback(
    (faxInstructions: any, emailInstructions: any) =>
      printingService.printDaChart(
        printConfig,
        patient!,
        undefined,
        undefined,
        faxInstructions,
        undefined,
        emailInstructions,
      ),
    [printingService, printConfig, patient],
  );

  const { print, fax, email } = usePrintDispatch(
    getPrintPromise,
    () => {
      setAnchorEl(null);
      setLoading(true);
    },
    () => setLoading(false),
  );

  const guard = (fn: () => void) => () => {
    if (patient) fn();
  };

  return (
    <>
      {loading &&
        createPortal(
          <Loader />,
          document.getElementById('portal-container') || document.body,
        )}
      <StyledActionIcon
        Icon={HealingIcon}
        onClick={(e: any) => setAnchorEl(e.currentTarget)}
        id="poc-ribbon"
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={guard(print)}>Print</MenuItem>
        <MenuItem onClick={guard(fax)}>Fax</MenuItem>
        <MenuItem onClick={guard(email)}>Email</MenuItem>
      </Menu>
    </>
  );
};
